import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import SourceDetail from "../SourceDetail/SourceDetail";
import {
  BASE_BREADCRUMB_NODE,
  CATALOGUE_NODE,
  POINTING_NODE,
  SOURCE_DETAIL_NODE,
} from "../../constants";
import { AppContext } from "../../context/appContext";
import { breadcrumbNodesUpdated, sourceIdUpdated } from "../../redux/reducer";
import {
  useGetSourceDataByIdQuery,
  useGetSourceImagesByIdQuery,
  useGetSpectralPlotDataQuery
} from "../../redux/sourceService";


function SourceView() {
  const location = useLocation();
  const dispatch = useDispatch();
  let { sourceId,catalogueMetadataId } = useParams();
  let [pointingId, sourceDBId] = sourceId?.split("?source_id=") || [];
  const { data, isLoading } = useGetSourceDataByIdQuery({
    sourceId: sourceDBId,
    pointingId: pointingId,
    catalogueId:catalogueMetadataId
  });
  let { data: artefactsData, isLoading: isArtefactsRequestLoading } =
    useGetSourceImagesByIdQuery({
      sourceId: sourceDBId,
      catalogueId:catalogueMetadataId
    });
  
  const { toggleLoaderVisibility } = useContext(AppContext);


  useEffect(() => {
    if (isLoading) {
      toggleLoaderVisibility(true);
    } else {
      toggleLoaderVisibility(false);
    }
  }, [isLoading]);

  useEffect(() => {
    dispatch(sourceIdUpdated({ sourceId }));

    if (!location?.state?.internalNavigation && location?.state?.pointingsRefreshed) {
      dispatch(
        breadcrumbNodesUpdated({
          breadcrumbNodes: [...BASE_BREADCRUMB_NODE, ...POINTING_NODE, ...SOURCE_DETAIL_NODE],
        })
      );
    }
    else if(!location?.state?.internalNavigation && !location?.state?.pointingsRefreshed){
           dispatch(
        breadcrumbNodesUpdated({
          breadcrumbNodes: [...BASE_BREADCRUMB_NODE, ...SOURCE_DETAIL_NODE],
        })
      );
    }
    else {
      dispatch(
        breadcrumbNodesUpdated({
          breadcrumbNodes: [
            ...BASE_BREADCRUMB_NODE,
            ...CATALOGUE_NODE,
            ...POINTING_NODE,
            ...SOURCE_DETAIL_NODE,
          ],
        })
      );
    }
  }, []);



  if (isLoading) {
    return "Loading";
  }

  return (
    <>
      {sourceDBId ? (
        <SourceDetail
          data={data?.source_data}
          columnDesc={data?.source_view}
          artefactsData={artefactsData}
          isArtefactsRequestLoading={isArtefactsRequestLoading}
          catalogueMetadataId={catalogueMetadataId}
          sourceId={sourceDBId}
          getSpectralPlot={useGetSpectralPlotDataQuery}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default SourceView;
